<template>
  <el-table
      :data="data"
      :default-sort = "{prop: 'mapping_name', order: 'descending'}"
      style="width: 100%">
    <el-table-column
        sortable
        label="Mapping Name"
        prop="mapping_name">
    </el-table-column>
    <el-table-column
        sortable
        label="Area"
        prop="area_name">
    </el-table-column>
    <el-table-column
        :sortable="true"
        :formatter="setThousandSeparators"
        label="T Calls"
        prop="Total calls">
    </el-table-column>
    <el-table-column
        width="90px"
        sortable
        :formatter="setPercent"
        label="Fail"
        prop="Fail">
    </el-table-column>
    <el-table-column
        width="110px"
        sortable
        :formatter="setPercent"
        label="Success"
        prop="Success">
    </el-table-column>
    <el-table-column
        width="90px"
        sortable
        :formatter="setPercent"
        label="Answ"
        prop="Answered">
    </el-table-column>
    <el-table-column
        width="100px"
        sortable
        label="AVD"
        prop="Average call duration">
    </el-table-column>
    <el-table-column
        sortable
        :formatter="setThousandSeparators"
        label="T Time (M)"
        prop="Total call time">
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  props: {
    data: {
      required: true
    },
  },
  methods: {
    setThousandSeparators (row, column) {
      return this.formatNumber(row[column.property]);
    },
    setPercent (row, column) {
      return row[column.property] + "%";
    },
    formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    }
  }
}
</script>
